import { render, staticRenderFns } from "./dj-lang.vue?vue&type=template&id=178f8166"
import script from "./dj-lang.vue?vue&type=script&lang=js"
export * from "./dj-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports